import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SsSortDirective } from './ss-sort.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SsSortDirective],
  exports: [SsSortDirective],
})
export class SsSortModule {}
